import React from 'react';
import { AvTooltip } from '@fabric-ui/components';
import { Calendar } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { Box, BoxProps, Fade, SvgIcon, Typography } from '@mui/material';
import format from 'date-fns/format';
import { WidgetHistoricLoadingAnimation } from './WidgetHistoricLoadingAnimation';
import { WidgetHistoricLoadingContent } from './WidgetLoadingState.utils';

const getDataUpdateAtText = (dataUpdateAt: Date) => `Data last updated on ${format(dataUpdateAt.getTime(), 'yyyy-MM-dd HH:mm:ss')} UTC`;

type FloatingWidgetLoadingStateProps = {
  isLoading?: boolean;
  dataUpdateAt?: Date;
  /** Only if true the loader will render, otherwise returns a regular Box. Temporary prop to ease feature flag for this feature. to be removed https://jira.corp.zscaler.com/browse/AVA-14774 */
  enabled?: boolean;
} & BoxProps;
const FloatingWidgetLoadingState = ({
  children,
  isLoading = false,
  dataUpdateAt,
  enabled = false,
  ...props
}: FloatingWidgetLoadingStateProps) => (
  <Box {...props} sx={{ position: 'relative', ...props.sx }}>
    {!enabled ? (
      children
    ) : (
      <>
        <Fade in={isLoading}>
          <Box
            sx={{
              width: 120,
              height: 120,
              position: 'absolute',
              left: 1,
              bottom: 1,
              p: 2,
              background:
                'linear-gradient(45deg, var(--color-surface-base-primary) 0%, var(--color-surface-base-primary) 50%, transparent 100%)',
              zIndex: 1,
              ...flex.justifyStart,
              ...flex.itemsEnd,
            }}>
            <AvTooltip muiProps={{ placement: 'right' }} title={<WidgetHistoricLoadingContent />}>
              <WidgetHistoricLoadingAnimation sx={{ height: 48, width: 48 }} />
            </AvTooltip>
          </Box>
        </Fade>
        {dataUpdateAt ? (
          <Typography
            sx={{
              position: 'absolute',
              gap: 1,
              bottom: 1,
              right: 1,
              fontSize: 12,
              fontWeight: 600,
              p: t => t.spacing(0.5, 0.75),
              color: 'var(--color-content-immutable-white)',
              background: 'var(--color-surface-immutable-darkGrey)',
              borderTopLeftRadius: t => t.spacing(0.5),
              zIndex: 1,
              opacity: 0.9,
              pointerEvents: 'none',
              ...flex.itemsCenter,
            }}
            variant="body1">
            {getDataUpdateAtText(dataUpdateAt)}
            {/* SvgIcon Adds MUI accessability and theme options */}
            <SvgIcon sx={{ '& svg': { width: 16, height: 16 }, fontSize: 18 }}>
              <Calendar viewBox="0 0 20 20" />
            </SvgIcon>
          </Typography>
        ) : null}
        {children}
      </>
    )}
  </Box>
);

export default FloatingWidgetLoadingState;
